import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationDecimalValue,
  getMutationIsActive,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for crisis event data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listCrisisEvents(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        startTime
        endTime

        severity
        status

        location
        latitude
        longitude

        details

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for crisis event data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertCrisisEvent(
        input: {
          ${getMutationStringValue(doc, 'id')}

          ${getMutationStringValue(doc, 'startTime')}
          ${getMutationStringValue(doc, 'endTime')}

          ${getMutationStringValue(doc, 'severity')}
          ${getMutationStringValue(doc, 'status')}

          ${getMutationStringValue(doc, 'location')}
          ${getMutationDecimalValue(doc, 'latitude')}
          ${getMutationDecimalValue(doc, 'longitude')}

          ${getMutationStringValue(doc, 'details')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize crisis event data with GraphQL endpoint
 */
export const syncCrisisEvent = (...args) => {
  return buildReplication(
    ...args,
    'crisisEvent',
    { pullBuilder, pullQuery: 'listCrisisEvents' },
    { pushBuilder }
  );
};
